import { ProtocolDistributor } from './protocol-distributor';
import { DEFAULT_PROTOCOL_ID } from './constants';
/**
 * ProtocolBaseService is not injectable, but it has platform-specific children which can be injected.
 */
export class ProtocolBaseService {
  constructor(registry) {
    this.registry = registry;
  }
  get(name, allowFallback = true) {
    const p = this.registry.get(name);
    if (p) return p;
    if (!allowFallback) return null;
    console.warn('protocol with name "' + name + '" not found, falling back to default protocol');
    return this.registry.get(DEFAULT_PROTOCOL_ID);
  }
  // NOTE: assignLoggers MUST be called afterwards!
  create(info) {
    const protocol = new ProtocolDistributor(this.registry, info.name);
    if (info.displayName) protocol.setDisplayName(info.displayName);
    return protocol;
  }
  addDefaultLogger(Ctor) {
    this.registry.registerDefaultLogger(Ctor);
  }
}